/*
 * @Author: LUOHM
 * @Date: 2021-04-21 10:50:20
 * @LastEditTime: 2022-05-11 10:11:34
 * @LastEditors: LUOHM
 */
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from './language'

Vue.use(VueI18n)


// 通过选项创建 VueI18n 实例
export default  new VueI18n({
  fallbackLocale: 'en',
  messages,
})
